window.TV2 = window.TV2 || {};

function isRecentlyUpdated(articleResponse, loadedTimestamp) {
  return (
    articleResponse.result &&
    articleResponse.result.length &&
    articleResponse.result[0].modified > loadedTimestamp
  );
}

window.TV2.pollArticleUpdated = url => {
  const articleLoadedTimestamp = Date.now() / 1000;
  const pollInterval = setInterval(() => {
    fetch(url)
      .then(res => res.json())
      .then(data => {
        if (isRecentlyUpdated(data, articleLoadedTimestamp)) {
          clearInterval(pollInterval);
          const el = document.querySelector('.update-article-wrapper');
          el.style.display = 'block';
          el.style.setProperty('--background-size', `${el.offsetWidth * 1.5}px`);
        }
      })
      .catch(() => {
        clearInterval(pollInterval);
      });
  }, 30000);

  document.querySelector('.update-article__button').addEventListener('click', () => {
    window.location.reload();
  });
};
